import React, { useState, createContext, Dispatch, SetStateAction, useContext } from 'react';
import { PersonFragment } from '@graphql/generated';

export type SelectedPeopleDispatch = Dispatch<SetStateAction<ReadonlyArray<Partial<PersonFragment>>>>;

export type SelectedPeople = ReadonlyArray<Partial<PersonFragment & { full_name: string; hasPhone?: boolean }>>;

export const PeopleContext = createContext<{
  selectedPeople: SelectedPeople;
  setSelectedPeople: SelectedPeopleDispatch;
  clearSelectedPeople: () => void;
}>({
  selectedPeople: [],
  setSelectedPeople() {},
  clearSelectedPeople() {},
});

export const PeopleProvider = (props: { children: React.ReactNode }) => {
  const [selectedPeople, setSelectedPeople] = useState<ReadonlyArray<Partial<PersonFragment>>>([]);

  const clearSelectedPeople = () => {
    setSelectedPeople([]);
  };

  return (
    <PeopleContext.Provider
      value={{
        selectedPeople,
        setSelectedPeople,
        clearSelectedPeople,
      }}
    >
      {props.children}
    </PeopleContext.Provider>
  );
};

export const usePeopleContext = () => {
  return useContext(PeopleContext);
};
